import { API } from '../../../lib/api/api';
import axios from 'axios';

// function to delete all instagram scheduled posts from our rds database
export const deleteAllInstagramScheduledPosts = async (userId: string) => {
	try {
		return await axios.get(
			`${API}instagram/deleteUserScheduledPosts?auth0UserId=${userId}`
		);
	} catch (e) {
		return {
			error: e,
			status: 'error',
			statusText: 'There was an error. Your scheduled posts were not deleted.',
			data: e
		};
	}
};
